import AddButton from 'components/buttons/AddButton'
import DoctorListAction from 'components/data-table/data-table-action/admin-action/DoctorListAction';
import PatientListAction from 'components/data-table/data-table-action/admin-action/PatientListAction';
import DataTable from 'components/data-table/DataTable'
import Loader from 'components/loader/Loader'
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Col, Container, Row } from 'reactstrap'
import { PatientListRes, PatientListTodo } from 'redux/slice/admin/patient/PatientList';

class PatientList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bool: false
        };
    }

    

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ loading: true });
        dispatch(PatientListTodo()).then(() => this.List_res());
    }

    componentDidUpdate(prevProps, prevState) {
        const { dispatch } = this.props;
        if (prevState.bool !== this.state.bool) {
            dispatch(PatientListTodo()).then(() => this.List_res());
        }
    }

    setBool = () => {
        this.setState(prevState => ({ bool: !prevState.bool }));
    }


    List_res = () => {
        if (PatientListRes?.success) {
            this.setState({ loading: false });
        } else if (PatientListRes?.error?.status == 401) {
            localStorage.clear()
            this.props.history.push('/admin/login');
        } else {
            this.setState({ loading: false });
        }
    }
    render() {

        const { loading, bool } = this.state;
        const { PatientList } = this.props;
        const columnDefs = [
            {
                headerName: 'S.NO',
                valueGetter: 'node.rowIndex + 1',
                filter: 'false',
                suppressMenu: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 90
            },
            {
                headerName: 'NAME',
                field: 'name',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },

            {
                headerName: 'CONTACT',
                field: 'phone',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'EMAIL',
                field: 'email',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'AGE',
                field: 'age',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 80
            },
            {
                headerName: 'GENDER',
                field: 'gender',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 120

            },
            {
                headerName: 'STATUS',
                field: 'status',
                filter: 'agTextColumnFilter',
                // cellRenderer: params => (
                //     <span className={params.value === 'Active' ? 'badge bg-success' : 'badge bg-danger'}>
                //         {params.value}
                //     </span>
                // ),
                cellRenderer: params => params.value === 'Active' ? <span className='active-status'>Active</span> : <span className='inactive-status'>Inactive</span>,
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 120
            },
            {
                field: 'ACTIONS',
                cellRenderer: PatientListAction,
                cellRendererParams: {
                    bool: bool,
                    setBool: this.setBool,
                },
                autoHeight: true,
                pinned: 'right',
                maxWidth: 120,
            }
        ];
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h4 className="mb-0 font-size-18">Patient List</h4>
                            <Link to='/admin/add-patient'> <AddButton name={"ADD Patient"} /></Link>
                        </div>
                        <Row>
                            <Col xl='12' className='mt-2'>
                                {loading ?
                                    <div className='dd-flex justify-content-center p-5'>
                                        <Loader />
                                    </div> :
                                    <DataTable
                                        rowData={PatientList}
                                        columnDefs={columnDefs}
                                        height={'70vh'}
                                    />}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    PatientList: state?.PatientList?.data?.data,
    // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});
export default connect(mapStateToProps)(PatientList)
